"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_router_dom_1 = require("react-router-dom");
var CardBox_1 = require("components/CardBox");
var Thumbnails_1 = require("components/Thumbnails");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('selectedFileUuid', 'setSelectedFileUuid', undefined), (0, recompose_1.withState)('mobileButtons', 'setMobileButtons', false), react_router_dom_1.withRouter, recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(CardBox_1.CardBox, { title: "images" },
        React.createElement(sok_ui_1.Button, { className: "upload-images", icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }), color: 'base-green', text: (0, translation_1.getLocalization)('diaryEntryView/images/add'), size: "large", disabled: props.isDisabled, onClick: props.handleUpload }),
        props.imagesStatus === 'FETCHING' ||
            props.filesCrudStatus === 'SAVING' ? (React.createElement("div", null,
            React.createElement(sok_ui_1.LoadingSpinner, null))) : (React.createElement(Thumbnails_1.Thumbnails, { items: props.images, onDelete: props.isDisabled ? false : props.handleOnDeleteClick, onEdit: props.handleEdit, size: props.viewportSize, localizationPrefix: 'global/' }))));
});
